module.exports = __webpack_public_path__ + "static/img/bg1.943a524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/bg1.jpg
// module id = M+aB
// module chunks = 0